<ng-container *transloco="let t; prefix: 'onboarding.onboarding-seller'">
    <section class="container mb-10">
        <div class="flex flex-row gap-14">
            <div class="flex-1">
                <h2 class="text-black font-semibold text-[2.5rem] mb-4">{{t('registration-completed.title')}}</h2>
                <p class="text-2xl text-gray-900">{{t('registration-completed.infotext')}}</p>
            </div>
            <img class="max-w-[262px]" src="assets/img/on-boarding/on-boarding-laptop-home.png"
                alt="On boarding buyer 4">
        </div>
    </section>
    <section class="container mb-10">
        <h4 class="font-semibold text-gray-900 mb-4">{{t('registration-completed.property-preference')}}</h4>
        <div class="p-4 rounded bg-white grid md:grid-cols-2 grid-cols-1 gap-x-8 gap-y-8">
            <div class="flex flex-row items-center justify-between">
                <p class="flex-1 text-gray-800">{{t('registration-completed.property-types')}}</p>
                <p class="flex-1 text-black font-semibold">{{PropertyTypes}}</p>
            </div>
        </div>
    </section>
    <section class="container mb-10">
        <h4 class="font-semibold text-gray-900 mb-4">{{t('registration-completed.support-preference')}}</h4>
        <div class="p-4 rounded bg-white grid md:grid-cols-2 grid-cols-1 gap-x-8 gap-y-8">
            <div class="flex flex-row items-center justify-between">
                <p class="flex-1 text-gray-800">{{t('registration-completed.support-types')}}</p>
                <p class="flex-1 text-black font-semibold">{{SupportTypeString}}</p>
            </div>
        </div>
    </section>
    <section #callback class="container">
        <app-experts-callback [modalComponent]="'GeneralCallbackModal'"></app-experts-callback>
    </section>
</ng-container>